module.exports = __webpack_public_path__ + "static/media/verify-your-email.d5e80992.svg";